var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 36,
    fill: "none",
    viewBox: "0 0 106 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.433 15.353H63.316v-4.266c0-3.704 2.094-5.37 7.41-5.37 2.631 0 3.189.035 3.189.035V.544S72.937.348 69.82.348c-7.902 0-13.386 3.437-13.386 10.257V36h6.882V20.653h10.117zM93.873 15.353H83.756v-4.266c0-3.704 2.094-5.37 7.41-5.37 2.631 0 3.189.035 3.189.035V.544s-.982-.196-4.112-.196c-7.933 0-13.438 3.437-13.438 10.257V36h6.951V20.653h10.048zM98.622.487 98.632 36h6.872V.487zM51.41 13.563h-6.882V36h6.882zM47.979 10.241a4.193 4.193 0 1 0 0-8.385 4.193 4.193 0 0 0 0 8.385M6.813 11.529s7.889-5.308 15.747-5.308c6.784 0 11.107 3.201 11.107 7.78 0 4.633-4.222 7.772-11.006 7.772-7.858 0-15.848-5.3-15.848-5.3zM0 35.999h6.813V23.72s9.405 4.767 16.413 4.767c10.707 0 16.723-6.2 16.723-14.496C39.949 5.694 33.933 0 23.226 0 13.64 0 6.813 5.271 6.813 5.271V.488H0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h106v36H0z"
  })))));
};
export default SvgLogo;